import ViewBase from '../../view-base.view';
import aiJpoModel from '../../../models/schedule/ai-jpo.model';
import languageModel from '../../../models/language.model';
import { Dialog, Spinner, EmptyState, Icons } from 'construct-ui';

export default function StorePopupDialog() {
    ViewBase.call(this);

    let stores = [];
    let group = {};
    let isOpen = false;

    let loadStores = () => {
        aiJpoModel.getSummaryStoresPopup({
            groupId: group.groupID,
            month: group.month
        })
            .then((result) => {
                stores = result || [];
            })
            .catch((error) => {
                this.handleError(error);
            });
    };

    return {
        oninit: ({ attrs }) => {
            isOpen = attrs.isOpen;
            group = attrs.group || {};
            if (isOpen) loadStores();
        },
        onupdate: ({ attrs }) => {
            if (attrs.isOpen !== isOpen) {
                isOpen = attrs.isOpen;
                if (isOpen) {
                    group = attrs.group || {};
                    loadStores();
                }
            }
        },
        view: ({ attrs }) => {
            if (!isOpen) return null;

            const title = (group.groupName || '') + ' — ' + (group.storeCount ?? 0) + ' ' + languageModel.getText('', 'Stores');

            return m(Dialog, {
                class: 'cui-dialog-l',
                isOpen: isOpen,
                onClose: attrs.onClose,
                title: title,
                content: [
                    m('.table-responsive',
                        m('table.table.table-bordered',
                            m('thead.thead-bggrey',
                                m('tr.align-middle', [
                                    m('th', { scope: 'col' }, languageModel.getText('', 'Store Code')),
                                    m('th', { scope: 'col', style: 'width: 130px;' }, languageModel.getText('', 'Latitude')),
                                    m('th', { scope: 'col', style: 'width: 130px;' }, languageModel.getText('', 'Longitude')),
                                    m('th', { scope: 'col', style: 'width: 80px;' }, languageModel.getText('', 'Grade')),
                                ])
                            ),
                            m('tbody',
                                stores.length === 0 &&
                                    m('tr.align-middle',
                                        m('td', { colspan: '4' }, languageModel.getText('', 'No records found.'))
                                    ),
                                stores.map((s) =>
                                    m('tr', [
                                        m('td', s.storeCode || ''),
                                        m('td.text-end', s.latitude != null ? Number(s.latitude).toFixed(6) : ''),
                                        m('td.text-end', s.longitude != null ? Number(s.longitude).toFixed(6) : ''),
                                        m('td.text-center',
                                            m('span.ai-jpo-grade.ai-jpo-grade-' + (s.grade || '').toLowerCase(), s.grade || '')
                                        ),
                                    ])
                                )
                            )
                        )
                    )
                ]
            });
        }
    };
}
